import { translateFunc } from "client/utils/translateFunc";
import { Modal } from "../Modal/Modal";
import { Translate } from "../Translate/Translate";

export interface DeleteModalProps {
    isOpen: boolean;
    close: () => void;
    handleDelete: () => void;
}

export const DeleteModal = ({ isOpen, close, handleDelete }: DeleteModalProps) => {
    return (
        <Modal isOpen={isOpen} close={close}>
            <div className="flex justify-center items-center h-screen" onClick={close}>
                <div
                    className="inline-flex flex-col items-center bg-white dark:bg-darkSurface-300 rounded-lg py-12 px-16 gap-10"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="text-xl font-semibold capitalize text-black dark:text-white">
                        <Translate keyName="common:delete-all-images" />?
                    </div>
                    <div className="flex items-center gap-8 font-semibold">
                        <div
                            className="cursor-pointer px-12 py-2 bg-irGray-400 dark:bg-darkSurface-200 dark:hover:bg-darkSurface-100 hover:bg-irGray-600 rounded-xl capitalize"
                            onClick={close}
                            data-testid="cancel-delete"
                        >
                            <Translate keyName="common:cancel" />
                        </div>
                        <div
                            className="cursor-pointer px-12 py-2 bg-irRed-400 hover:bg-red-700 text-white rounded-xl capitalize"
                            onClick={handleDelete}
                            data-data-testid="confirm-delete"
                        >
                            {`${translateFunc("common:yes")}, ${translateFunc("common:delete")}`}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
